// extracted by mini-css-extract-plugin
export default {"right":"number_right__NMSdd","left":"number_left__VWOM7","center":"number_center__Ow+0V"};